import type {State} from 'src/reducers';


export const selectTabErrors = (state: State): Set<string> =>
  // @ts-expect-error - TS2339 - Property 'tabs' does not exist on type 'DefaultRootState'.
  state.errors.tabs;
